import { FaEye } from "react-icons/fa";

export const Proj1 = () => {
  return (
    <article className="relative rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-shadow duration-500 bg-white/5 backdrop-blur-sm">
      {/* Project Image */}
      <img src="/img/projects/anton.png" alt="AnnConnect Offline Exam" className="w-full h-64 md:h-72 object-cover rounded-t-2xl" loading="lazy" />

      {/* Project Info */}
      <div className="p-6 space-y-4 mt-4">
        <h3 className="text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500">AnnConnect Offline Exam</h3>
        <p className="text-gray-600 text-lg leading-relaxed">AnnConnect Offline Exam is a secure platform for conducting and managing offline exams. It simplifies the process for both educators and students with easy exam creation, monitoring, and reporting.</p>
        <div className="flex justify-center">
          <a href="https://anton.api-annconnect.com/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center px-5 py-2 rounded-xl font-semibold text-white shadow-md bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 hover:scale-105 transition-transform duration-300">
            <FaEye className="mr-2" /> View
          </a>
        </div>
      </div>
    </article>
  );
};
